import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/Layout";
import Analytics from "@/components/Analytics";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Resources from "@/pages/Resources";
import ArticleDetail from "@/pages/ArticleDetail";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import ServicePage from "@/pages/ServicePage";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Analytics />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/how-i-help" element={<Navigate to="/" replace />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:slug" element={<ProjectDetail />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<ArticleDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/commercial-signs-richmond-va" element={<ServicePage slug="commercial-signs-richmond-va" />} />
            <Route path="/storefront-signs-richmond-va" element={<ServicePage slug="storefront-signs-richmond-va" />} />
            <Route path="/monument-signs-richmond-va" element={<ServicePage slug="monument-signs-richmond-va" />} />
            <Route path="/sign-installation-richmond-va" element={<ServicePage slug="sign-installation-richmond-va" />} />
            <Route path="/new-business-signage-richmond-va" element={<ServicePage slug="new-business-signage-richmond-va" />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
